import { BillStatus } from '@features/bills/enums/billStatus'

import { BillsTableActionType } from '../enums/billsTableActionType'

/**
 * Actions available per derived status, in display order.
 */
export const billStatusToActionTypes: Record<Exclude<BillStatus, BillStatus.All>, BillsTableActionType[]> = {
  [BillStatus.Draft]: [BillsTableActionType.Edit, BillsTableActionType.Duplicate, BillsTableActionType.Void],
  [BillStatus.Unpaid]: [
    BillsTableActionType.RegisterPayment,
    BillsTableActionType.Edit,
    BillsTableActionType.Duplicate,
    BillsTableActionType.CreateCreditNote,
    BillsTableActionType.Void,
  ],
  [BillStatus.Overdue]: [
    BillsTableActionType.RegisterPayment,
    BillsTableActionType.Edit,
    BillsTableActionType.Duplicate,
    BillsTableActionType.CreateCreditNote,
    BillsTableActionType.Void,
  ],
  [BillStatus.PartiallyPaid]: [
    BillsTableActionType.RegisterPayment,
    BillsTableActionType.Edit,
    BillsTableActionType.Duplicate,
    BillsTableActionType.CreateCreditNote,
    BillsTableActionType.Void,
  ],
  [BillStatus.Paid]: [
    BillsTableActionType.Edit,
    BillsTableActionType.Duplicate,
    BillsTableActionType.CreateCreditNote,
    BillsTableActionType.VoidPayment,
    BillsTableActionType.Void,
  ],
  [BillStatus.Voided]: [],
}
